import { ref } from '@vue/composition-api';
import { http, MediaUtils } from '@article/pixel';
import Tracking from '@/components/commons/Tracking.js';
import { trackEvent, scrollTop } from '@/components/commons/utils.js';
import { trackProductAddToCart } from '@/components/commons/AlgoliaAnalytics.js';
import { animateAddCart } from './animateAddCart.js';
import LocalStorage, { LocalStorageKeys } from '@/components/commons/LocalStorage';

export function parseProducts(products) {
  return products.map((product) => ({ productId: product.id, quantity: product.quantity }));
}

async function addCart(products) {
  trackEvent('Checkout', 'Add to Cart');
  LocalStorage.remove(LocalStorageKeys.QUOTE_ID);
  await http.post('/api/cart/add', { items: parseProducts(products) });
}

export default function useAddToCart() {
  const isAddingCart = ref(false);

  function toggleAddingCart() {
    isAddingCart.value = !isAddingCart.value;
  }

  async function addCartProcess({ products, buttonToAnimate = null, scrollFirst = false }) {
    scrollFirst && scrollTop();
    toggleAddingCart();

    try {
      if (!MediaUtils.isTabletAndSmaller && buttonToAnimate) {
        await Promise.all([addCart(products), animateAddCart(buttonToAnimate)]);
      } else {
        await addCart(products);
      }
    } catch (error) {
      console.error(error);
      Tracking.sentryCaptureError(error);
    }

    toggleAddingCart();

    try {
      // Only send Algolia events when adding single product to cart, sets are not supported
      if (products && products.length === 1) {
        trackProductAddToCart(products[0].id);
      }
    } catch (e) {
      Tracking.sentryCaptureError(e);
    }
  }

  return {
    isAddingCart,
    addCartProcess,
  };
}
